import type { Http } from './http';
import type { BillingProfile, CompanyBilling, CompanySummary, Invoice, Lang } from './saas';

/**
 * The signed-in company user's own company (docs/SAAS.md §4.2) — the admin's legacy session, the
 * v1 envelope. Billing, invoices and the profile are for the company's ADMINs.
 */
export function createCompanyApi(http: Http) {
  return {
    summary: () => http.request<CompanySummary>('GET', '/api/v1/company'),
    billing: () => http.request<CompanyBilling>('GET', '/api/v1/company/billing'),
    updateProfile: (body: Omit<BillingProfile, 'name' | 'code'>) => http.request<BillingProfile>('PUT', '/api/v1/company', { body }),
    invoices: () => http.request<Invoice[]>('GET', '/api/v1/company/invoices'),
    async invoicePdf(id: string, lang: Lang) {
      const res = await http.raw('GET', `/api/v1/company/invoices/${id}/pdf`, { query: { lang } });
      const disposition = res.headers.get('content-disposition') ?? '';
      return { blob: await res.blob(), filename: /filename="?([^";]+)"?/.exec(disposition)?.[1] ?? `invoice-${id}.pdf` };
    },
  };
}

export type CompanyApi = ReturnType<typeof createCompanyApi>;
